import {
  CatPricingAnalysisResponseDto,
  CatPricingSummaryResponseDto,
  FireModifierResponseDto,
  FirePricingAnalysisResponseDto,
  FirePricingAnalysisTotalRowResponseDto,
  FirePricingSummaryResponseDto,
  GetTailoredResultQueryDtoPerilEnum,
  GetTailoredResultQueryDtoPriceRatingTypeEnum,
  GetTailoredResultQueryDtoSeverityEnum,
  GetTailoredResultQueryDtoTailoredResultTypeEnum,
  PaginationDto,
  CatPricingAnalysisTotalRowResponseDto,
  LayerElcTotalDto,
} from 'libs/pinnacle-sdk';
import { axiosInstance } from './axios-instance';

// We need to create a custom API class for the price rating
// because the API is not following the standard API pattern
// so that openapi-generator-cli cannot generate the API correctly
export class PriceRatingApi {
  public getFirePricingSummary = async (
    submissionId: string,
    currency: string
  ): Promise<FirePricingSummaryResponseDto[]> => {
    const response = await axiosInstance.post(
      `/submission/${submissionId}/price-rating/get-tailored-result`,
      {
        priceRatingType:
          GetTailoredResultQueryDtoPriceRatingTypeEnum.FireRating,
        tailoredResultType:
          GetTailoredResultQueryDtoTailoredResultTypeEnum.FirePricingSummary,
        currency,
      }
    );
    return response.data;
  };

  public getCatPricingSummary = async (
    submissionId: string,
    currency: string
  ): Promise<CatPricingSummaryResponseDto[]> => {
    const response = await axiosInstance.post(
      `/submission/${submissionId}/price-rating/get-tailored-result`,
      {
        priceRatingType: GetTailoredResultQueryDtoPriceRatingTypeEnum.CatRating,
        tailoredResultType:
          GetTailoredResultQueryDtoTailoredResultTypeEnum.CatPricingSummary,
        currency,
      }
    );
    return response.data;
  };

  public getFireModifiers = async (
    submissionId: string
  ): Promise<FireModifierResponseDto> => {
    const response = await axiosInstance.post(
      `/submission/${submissionId}/price-rating/get-tailored-result`,
      {
        priceRatingType:
          GetTailoredResultQueryDtoPriceRatingTypeEnum.FireRating,
        tailoredResultType:
          GetTailoredResultQueryDtoTailoredResultTypeEnum.FireModifiers,
      }
    );
    return response.data;
  };

  public getFirePricingAnalysis = async (
    submissionId: string,
    query?: {
      page?: number;
      pageSize?: number;
      searchText?: string;
      countries?: string[];
      occupancies?: string[];
      severity?: GetTailoredResultQueryDtoSeverityEnum;
      includeTotalRow?: boolean;
      currency?: string;
    }
  ): Promise<{
    items: FirePricingAnalysisResponseDto[];
    pagination: PaginationDto;
    totalRow?: FirePricingAnalysisTotalRowResponseDto;
  }> => {
    const response = await axiosInstance.post(
      `/submission/${submissionId}/price-rating/get-tailored-result`,
      {
        priceRatingType:
          GetTailoredResultQueryDtoPriceRatingTypeEnum.FireRating,
        tailoredResultType:
          GetTailoredResultQueryDtoTailoredResultTypeEnum.FirePricingAnalysis,
        searchText: query?.searchText,
        severity: query?.severity,
        includeTotalRow: query?.includeTotalRow,
        countries: query?.countries,
        occupancies: query?.occupancies,
        currency: query?.currency,
      },
      {
        params: {
          page: query?.page,
          pageSize: query?.pageSize,
        },
      }
    );
    return response.data;
  };

  public getCatPricingAnalysis = async (
    submissionId: string,
    peril: GetTailoredResultQueryDtoPerilEnum,
    query?: {
      page?: number;
      pageSize?: number;
      searchText?: string;
      includeTotalRow?: boolean;
      countries?: string[];
      currency?: string;
    }
  ): Promise<{
    items: CatPricingAnalysisResponseDto[];
    pagination: PaginationDto;
    totalRow?: CatPricingAnalysisTotalRowResponseDto;
    layersElcTotal?: LayerElcTotalDto[];
  }> => {
    const response = await axiosInstance.post(
      `/submission/${submissionId}/price-rating/get-tailored-result`,
      {
        priceRatingType: GetTailoredResultQueryDtoPriceRatingTypeEnum.CatRating,
        tailoredResultType:
          GetTailoredResultQueryDtoTailoredResultTypeEnum.CatPricingAnalysis,
        searchText: query?.searchText,
        peril,
        countries: query?.countries,
        includeTotalRow: query?.includeTotalRow,
        currency: query?.currency,
      },
      {
        params: {
          page: query?.page,
          pageSize: query?.pageSize,
        },
      }
    );
    return response.data;
  };
}
